function verticalMenu(){
    document.querySelectorAll('.vertical-menu__item-btn').forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            const menuLi = e.target.closest('.vertical-menu__item');
            const subMenu = menuLi.querySelector('.vertical-menu__submenu');
            subMenu.slideToggle(200, function(){
                /*
                Состояния пункта меню:
                - Если у пункта меню есть оба класса "selected" и "active" - то находимся в разделе, имеющем подразделы
                - Если у пункта меню один класс "active" - мы находимся в дочернем разделе,
                родитель которого имеет подразделы
                 */
                if(menuLi.classList.contains('vertical-menu__item_active')){
                    btn.classList.toggle('vertical-menu__item-btn_hide');
                    // подставлять класс submenu-btn-hide,
                    // при котором стрелка свернута
                } else {
                    btn.classList.toggle('vertical-menu__item-btn_show');
                    // если мы не находимся в разделе или подразделе этого пункта
                    // меню, то подставлять класс submenu-btn-show, при котором стрелка развернута
                }
            });
        });
    });

    // slide submenu on click
    document.querySelectorAll('.vertical-menu .submenu-toggle').forEach(submenuToggle => {
        submenuToggle.addEventListener('click', (e) => {
            e.preventDefault();
            const itemWrap = e.target.closest('.vertical-menu__item-wrap');
            itemWrap.querySelector('.vertical-menu__item-btn').click();
        });
    });
}

export default verticalMenu;